module.exports = __webpack_public_path__ + "fdce10079f284ea35ec127980e80cb45.pdf";